<template>
  <div class="modal_wrap system ic_commonModal" :class="{ on: show }">
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">정렬 선택</h1>
        </div>
        <div class="modal_con">
          <div class="form_wrap">
            <div class="check_table">
              <label v-for="(item, index) in sorts" :key="index"
                ><input
                  type="radio"
                  name="sort"
                  :value="item"
                  v-model="selectedValue"
                /><span>{{ item.label }}</span></label
              >
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" @click="close">닫기</button>
            <button class="btn2" @click="confirm">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sortModal',
  props: {
    show: Boolean,
    sorts: Array,
    value: Object,
  },
  data(props) {
    return {
      selectedValue: props.value,
    };
  },
  methods: {
    close() {
      this.selectedValue = this.value;
      this.$emit('close');
    },
    confirm() {
      this.$emit('close', this.selectedValue);
    },
  },
};
</script>
